function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_102",
  "data-name": "Grupo 102",
  transform: "translate(-18.671 -120.369)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_97",
  "data-name": "Grupo 97"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_95",
  "data-name": "Grupo 95"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_94",
  "data-name": "Grupo 94"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_41",
  "data-name": "Caminho 41",
  d: "M33.021,129.828l-.6-.568L36,125.444l3.906,3.577-.561.612-3.3-3.024Z",
  fill: "#efeeee"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_96",
  "data-name": "Grupo 96"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_42",
  "data-name": "Caminho 42",
  d: "M28.945,136.369a7.8,7.8,0,0,1-5.227-2.009l.557-.615a6.929,6.929,0,0,0,11.265-7.213l.791-.249a7.765,7.765,0,0,1-5.067,9.73A7.686,7.686,0,0,1,28.945,136.369Z",
  fill: "#efeeee"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_101",
  "data-name": "Grupo 101"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_99",
  "data-name": "Grupo 99"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_98",
  "data-name": "Grupo 98"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_43",
  "data-name": "Caminho 43",
  d: "M22.576,131.295l-3.906-3.577.561-.612,3.3,3.024,3.023-3.219.6.568Z",
  fill: "#efeeee"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_100",
  "data-name": "Grupo 100"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_44",
  "data-name": "Caminho 44",
  d: "M22.245,130.456a7.759,7.759,0,0,1,12.614-8.077l-.557.615a6.96,6.96,0,0,0-6.74-1.478,6.928,6.928,0,0,0-4.526,8.69Z",
  fill: "#efeeee"
}))));

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.235,
    height: 16,
    viewBox: "0 0 21.235 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.50303b20.svg";
export { ForwardRef as ReactComponent };